import React, { Component } from 'react';
import {
    Typography,
    Box,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Badge,
    withStyles
} from '@material-ui/core';
import { Add } from '@material-ui/icons';

const styles = theme => ({
    sectionBody: {
        padding: theme.spacing(2),
    },
    listItem: {
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#f8f9fa',
        },
    },
});

class RespondEstimateItemsSection extends Component {
    render() {
        const { classes, estimativa, onAbrirModalServicos } = this.props;

        if (!estimativa) {
            const { currentLanguage } = this.props;
            return (
                <Typography color="textSecondary" className={classes.sectionBody}>
                    {currentLanguage.bepiService.workshop.workshop_respond_no_estimate_loaded}
                </Typography>
            );
        }

        const itens = Array.isArray(estimativa.itens) ? estimativa.itens : [];

        return (
            <Box className={classes.sectionBody}>
                <List>
                    {itens.length > 0 ? (
                        itens.map((item, index) => (
                            <ListItem
                                key={index}
                                className={classes.listItem}
                                onClick={() => onAbrirModalServicos(item.servico_id)}
                            >
                                <ListItemText
                                    primary={item.servico}
                                    secondary={item.obs}
                                />
                                <ListItemSecondaryAction>
                                    <Badge badgeContent="+" color="primary">
                                        <Add />
                                    </Badge>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))
                    ) : (
                        <ListItem>
                            <ListItemText primary={this.props.currentLanguage.bepiService.workshop.workshop_respond_no_items_msg} />
                        </ListItem>
                    )}
                </List>
            </Box>
        );
    }
}

export default withStyles(styles)(RespondEstimateItemsSection);
